<template>
  <div>
    <!-- Toolbar da data table -->
    <v-toolbar flat>
      <v-toolbar-title class="font-weight-light">{{ title }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-text-field v-model="search" append-icon="search" label="Pesquisar" single-line hide-details></v-text-field>
      <v-spacer></v-spacer>

      <v-btn :disabled="loading" :loading="loading" :color="loading ? 'info' : 'info'" icon
        title="Inserir um novo registro" @click="addProduct();">
        <v-icon>add</v-icon>
      </v-btn>
    </v-toolbar>

    <!-- TABELA -->
    <v-data-table :loading="loading" :headers="headers" :search="search" :items="products" class="elevation-1"
      rows-per-page-text="Registros por Página" :rows-per-page-items="[10, 30, 50, 100]">
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">{{ props.item.code }}</td>
        <td class="text-xs-center">{{ props.item.description }}</td>
        <td class="text-xs-center">{{ props.item.stamp }}</td>
        <td class="text-xs-center">{{ props.item.unity }}</td>
        <td class="text-xs-center">{{ props.item.value | currency }}</td>
        <td class="text-xs-center">{{ props.item.category ? props.item.category.description : ""}}</td>
        <td class="text-xs-center">
          <v-chip small class="white--text font-weight-light"
            :color="props.item.active == false ? 'error' : 'success lighten-1' " :disabled="props.item.active == false">
            {{props.item.active == false ? 'Inativo' : 'Ativo'}}</v-chip>
        </td>
        <td class="justify-center layout px-0 text-xs-center">
          <v-btn icon round flat title="Editar" @click.prevent="edit(props.item);" color="info" :disabled="loading">
            <v-icon color="info">edit</v-icon>
          </v-btn>
        </td>

      </template>
      <template slot="pageText" slot-scope="props">
        {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
      </template>
      <template slot="no-data">
        <strong> {{footerDynamicText}} </strong>
      </template>
      <div slot="no-results" :value="true">
        <h3 class="text-xs-center">{{emptySearchText}} "{{ search }}".</h3>
      </div>
    </v-data-table>



    <!-- Confirmação de desativação da cidade -->
    <v-dialog v-model="desactivationDialog" persistent :overlay="true" max-width="500px" transition="dialog-transition">
      <v-toolbar class="elevation-1" card>
        <v-toolbar-title class="font-weight-light">
          {{desactivationDialogTitle}}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn color="error" title="Cancelar" icon round flat
            @click.stop.prevent="desactivationDialog = false, product.active = true">
            <v-icon large>clear</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card>
        <v-card-text>
          <p>Ao desativar um equipamento você perderá a função de utilizá-la em outras áreas</p>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success lighten-1" block outline round @click="desactivateproduct">Aceitar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Insersão Alteração dos dados da cidade -->
    <v-dialog v-model="dialog" persistent class="modal-size" max-width="900px">
      <v-card v-if="loading == false">
        <v-toolbar color="white" class="elevation-1">
          <v-toolbar-title class="black--text font-weight-light">{{formTitle}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-switch class="pt-switch" pt-2 v-if="product && product.active != undefined || null" :loading="loading"
              @click.prevent="product.active  == true ? desactivationDialog = true : activateProduct()"
              :label='product.active ? "Ativo" : "Inativo"' v-model="product.active"></v-switch>
            <v-btn title="Cancelar" @click="closeDialog" color="error" icon round flat>
              <v-icon large>clear</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-container fluid grid-list-lg>
          <v-card-text>
            <v-form lazy-valiadtion ref="form">
              <v-layout wrap row>
                <v-flex v-if="this.isEditing" xs12>
                  <v-text-field prepend-icon="code" box v-model="product.code" label="Código" disabled></v-text-field>
                </v-flex>

                <v-flex xs12>
                  <v-autocomplete label="Categoria do Produto" :rules="categoryRules" :items="categories" item-text="description"
                    v-model="product.category" prepend-icon="assignment_turned_in" dense return-object solo box>
                  </v-autocomplete>
                </v-flex>

                <v-flex xs12>
                  <v-text-field prepend-icon="label" :rules="inputRules" box v-model="product.description" label="Descrição" type="text">
                  </v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field prepend-icon="copyright"   v-model="product.stamp" label="Marca" type="text" box>
                  </v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-textarea prepend-icon="chrome_reader_mode" v-model="product.technicalSpecification"
                    @keyup="getStringWithLimit" label="Especificação Técnica" type="text" counter="500" rows="5"
                    no-resize box></v-textarea>
                </v-flex>
                <v-flex xs12>
                  <v-text-field prepend-icon="ac_unit" box v-model="product.unity" :rules="inputRules" label="Unidade de Medida"
                    type="text">
                  </v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-currency-field  box prependInnerIcon="attach_money" class="currency-prepend-outer-icon"
                    label="Valor Unitário (R$)" v-bind="currency_config" v-model="product.value">
                  </v-currency-field>
                </v-flex>
              </v-layout>
            </v-form>

          </v-card-text>
          <v-card-actions>
            <v-btn color="success lighten-1" round block :disabled="disabledButtonSave" @click.stop.prevent="save();">
              Salvar</v-btn>
          </v-card-actions>
        </v-container>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar.visible" :color="snackbar.color" multi-line :timeout="snackbar.timeout" vertical right
      button>
      <strong>{{snackbar.title}}</strong>
      <v-btn dark flat @click="snackbar.visible = false">
        Fechar
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
  import Limit from 'limit-string-length';
  import MessageFormatterUtil from '../utils/MessageFormatterUtil.js'
  import ProductService from "../service/ProductService.js";
  import ProductCategoryService from "../service/ProductCategoryService.js";
import Currency from '../utils/Currency';

  export default {
    data() {
      return {
        value: 0,
        currency_config: Currency.real,
        /**********\
      ***Rules***
      \**********/
        inputRules: [
          v => !!v || 'Campo obrigatório',
        ],
        categoryRules: [
          v => !!v || 'Selecione uma categoria'
        ],
        //CATEGORIAS //
        categories: [],
        products: [],

        // productsOffState: [],
        product: {},
        desactivationDialog: false,
        dialog: false,
        disabledButtonSave: false,
        headers: [{
            text: "Código",
            align: "center",
            value: "code"
          },
          {
            text: "Especificação / Descrição",
            align: "center",
            value: "description"
          },
          {
            text: "Marca",
            align: "center",
            value: "stamp"
          },
          {
            text: "Unidade de Medida",
            align: "center",
            value: "unity",
            sortable: false
          },
          {
            text: "Valor",
            align: "center",
            value: "value"
          },
          {
            text: "Categoria",
            align: "center",
            value: "description"
          },
          {
            text: "Situação",
            align: "center",
            value: "status",
            sortable: false
          },
          {
            text: "Ação",
            align: "center",
            sortable: false
          }
        ],
        loading: false,
        search: "",
        isEditing: false,
        index: undefined,

        /*********\
          ***Textos**
          \*********/
        desactivationDialogTitle: "Desativar Produto",
        emptyRecordsText: "Nenhum registro encontrado",

        emptySearchText: "Nenhum registro encontrado para",
        footerText: "Total de registros: ",
        loadingRecordsText: "Carregando registros...",
        title: "Produtos",
        snackbar: {
          visible: false,
          title: "",
          color: "",
          timeout: 6000
        },
      };
    },

    methods: {
      checkDuplicateRecord(product) {
        if (this.products.length > 0) {
          for (const p of this.products) {
            if (p.description &&
              p.stamp &&
              p.description.toUpperCase() == product.description.toUpperCase() &&
              p.stamp.toUpperCase() == product.stamp.toUpperCase()) return true;
          }
        }
        return false;
      },
      showSnackbar(message, color) {
        this.snackbar.color = color
        this.snackbar.title = message
        this.snackbar.visible = true
        this.snackbar.timeout = 6000
      }, //showSnackbar()

      closeDialog() {
        this.$refs.form.reset()
        this.dialog = false;
      },

      async initialize() {
        if (!this.loading) this.loading = true; //Se não estiver com o visual de carregamento, o ligar
        try {
          if (this.products.length < 1) this.snackbar.visible = false;

          this.products = await ProductService.getAll(); //Receber os registros da API
          this.savingproduct = false;
          this.search = ""; //Limpar dados
          this.dialog = false;
        } catch (error) {
          //Mandar o erro
          this.showSnackbar("Erro ao carregar as Categorias de Produtos!", "error");
          console.log(error);
        } finally {
          //Tirar o visual de carregamento
          this.loading = false;
        }
      }, //initialize()

      getStringWithLimit() {
        if (this.product.technicalSpecification) this.product.technicalSpecification = Limit(this.product
          .technicalSpecification,
          100, '');

        return '';
      },

      async fillCategories() {
        try {
          this.categories = await ProductCategoryService.getAll();
        } catch (error) {
          console.log(error);
        }
      },

      addProduct() {
        this.fillCategories();
        this.product = new Object();
        this.dialog = true;
      }, //addProduct()

      edit(item) {
        if (this.loading) return;
        this.fillCategories();
        this.isEditing = true;
        this.index = this.products.indexOf(item);
        this.product = this.products[this.index];
        this.product.value = item.value;
        this.dialog = true;
      }, //edit()

      async activateProduct() {
        try {
          this.desactivationDialog = false;
          this.savingproduct = true;
          this.product.active = true;
          this.dialog = false;
          await this.save();
          this.showSnackbar("Ativado com sucesso!", "success");
        } catch (error) {
          console.log(error);
        }
      }, //activateProduct()
      async desactivateproduct() {
        try {
          this.desactivationDialog = false;
          this.product.active = false;
          this.dialog = false;
          await this.save();
          this.showSnackbar("Desativado com sucesso!", "success");
        } catch (error) {
          console.log(error);
        }
      }, //desactivateproduct()
      async save() {
        if (this.$refs.form.validate()) {
          if (this.loading) return;

          this.loading = true;
          let errors = ProductService.validade(this.product)
          if (errors) {
            this.showSnackbar(MessageFormatterUtil.formatErrorMessage(errors), "error")
            this.loading = false
            return
          }

          let msgSnackbar = ""
          let type = ""

          try {
            if (this.product._id) {
              await ProductService.update(this.product);
              msgSnackbar = "Produto Alterado com Sucesso!";
              type = "success"
            } else {
              if (this.checkDuplicateRecord(this.product)) {
                msgSnackbar = "Registro Duplicado!";
                type = "error"
              } else {
                await ProductService.save(this.product);
                msgSnackbar = "Produto Salvo com Sucesso!";
                type = "success"
              }
            }
            this.showSnackbar(msgSnackbar, type);
          } catch (error) {
            this.showSnackbar("Erro ao salvar o Produto", "error");
            console.log(error);
          } finally {
            this.isEditing = false;
            this.initialize();
          }
        }

      },
      updateActivation() {
        console.log("product " + this.product.active);
        console.log("DesativationDialog " + this.desactivationDialog);
        if (this.product.active) this.desactivationDialog = true;
        else this.activateProduct();
        //product.active  == true ? desactivationDialog = true : activateProduct()
      }
    }, //methods
    computed: {
      formTitle() {
        return this.product._id ?
          "Editar Produto" :
          "Novo Produto";
      },
      footerDynamicText() {
        let text = this.loading ? this.loadingRecordsText : this.emptyRecordsText;
        return text;
      }
    }, //computed

    created() {
      this.initialize();
    }, //created()

    watch: {
      dialog(value) {
        value || this.initialize();
      },

      desactivationDialog: function () {
        if (!this.product) return;
        if (!this.product.hasOwnProperty("active")) return;
        if (this.product.active == undefined || null) return;
        if (this.savingproduct == true) {
          this.desactivationDialog = false;
        }
      }
    } //watch
  };

</script>
<style lang="css" scoped>
  >>>.pt-switch {
    padding-top: 20px;
  }

  >>>.currency-prepend-outer-icon>.v-input__control>.v-input__slot>.v-input__prepend-inner>.v-input__icon--prepend-inner>.v-icon {
    background-color: white !important;
    position: absolute;
    padding: 18px 5px;
    margin-right: 14px;
  }

</style>



// WEBPACK FOOTER //
// src/pages/Product.vue